// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-btn a[data-v-6bafe4db]{font-size:12px}.total-info[data-v-6bafe4db]{font-size:15px}.author-info p[data-v-6bafe4db]{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
